import { actions } from '../constants/elesson';
import * as actionTypes from '../../models/action/elesson';
import { IAction } from '../../models/action/core';



// #region Add Elesson Action
export function addElessonGetAction(data: actionTypes.IElessonData, spinnerId?: string, spinnerType?: 'get'|'set', callback?: (value: boolean) => void): actionTypes.IGetAddElesson {
    return {
        elessonData: data,
        timestamp: Date.now(),
        type: actions.ADD_ELESSON_ACTIVITY,
        spinnerId,
        spinnerType,
        callback
    };
}

export function setElessonDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_ELESSON_DATA_DEFAULT
    };
}

// Add Elesson Update Get Action
export function updateElessonGetAction(
    dataParams: actionTypes.IElessonParams,
    spinnerId: string,
    spinnerType: 'get'|'set'
): actionTypes.IUpdateElessonGet {
    return {
        ...dataParams,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_ELESSON_UPDATE_ACTIVITY
    };
}

export function addElessonSetAction(elessonData: actionTypes.IElessonData[] | null, spinnerId?: string, spinnerType?: 'get'|'set'): actionTypes.ISetAddElesson {
    return {
        elessonData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_ELESSON_SET_ACTIVITY
    };
}
// #endregion Add Elesson Action


// #region Add Elesson Action
export function deleteElessonGetAction(
    data: actionTypes.DeleteData
): actionTypes.IGetDeleteElesson {
    return {
        elessonData: data,
        timestamp: Date.now(),
        type: actions.DELETE_ELESSON_ACTIVITY
    };
}

export function deleteElessonSetAction(deleteElessonStatus: boolean): actionTypes.ISetDeleteElesson {
    return {
        deleteElessonStatus,
        timestamp: Date.now(),
        type: actions.DELETE_ELESSON_SET_ACTIVITY
    };
}

export function launchElesson(ActivityId: string, ClassId: string, EnrollmentId: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ILaunchElesson {
    return {
        ActivityId,
        ClassId,
        EnrollmentId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.LAUNCH_ELESSON,
    };
}
 // #endregion Add Elesson Action